"use client";

import { useRef } from "react";
import { ArrowRight, Wrench, Wind, Search, Waves, Hammer, ShieldCheck, Droplets } from "lucide-react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";
import { Link } from "@/components/common/Link";
gsap.registerPlugin(useGSAP, ScrollTrigger);
const services = [{
  title: "Fontanería",
  description: "Reparación e instalación de tuberías y grifería.",
  href: "/PlumbingPage",
  icon: Wrench
}, {
  title: "Climatización",
  description: "Instalación y mantenimiento de aire acondicionado.",
  href: "/AirConditioningPage",
  icon: Wind
}, {
  title: "Detección de fugas",
  description: "Localización sin obras con tecnología avanzada.",
  href: "/LeakDetectionPage",
  icon: Search
}, {
  title: "Piscinas",
  description: "Mantenimiento y reparación de sistemas de filtración.",
  href: "/PoolsPage",
  icon: Waves
}, {
  title: "Reformas",
  description: "Baños, cocinas y renovaciones completas.",
  href: "/RenovationsPage",
  icon: Hammer
}, {
  title: "Mantenimiento",
  description: "Revisiones preventivas anuales.",
  href: "/ServicesPage",
  icon: ShieldCheck
}, {
  title: "Filtración y Tratamiento de Agua",
  description: "Ósmosis inversa, descalcificación y filtración para el hogar y negocios.",
  href: "/WaterTreatmentAndFiltrationPage",
  icon: Droplets
}];
export default function Especialidades() {
  const container = useRef<HTMLElement>(null);
  useGSAP(() => {
    const mm = gsap.matchMedia();
    mm.add({
      reduced: "(prefers-reduced-motion: reduce)",
      normal: "(prefers-reduced-motion: no-preference)"
    }, ctx => {
      const {
        reduced
      } = ctx.conditions as {
        reduced: boolean;
      };
      if (reduced) {
        gsap.set([".bespoke-eyebrow", ".bespoke-heading", ".bespoke-cell"], {
          opacity: 1,
          y: 0
        });
        return;
      }
      const headerTl = gsap.timeline({
        scrollTrigger: {
          trigger: container.current,
          start: "top 82%"
        },
        defaults: {
          ease: "cubic-bezier(0.22, 0.61, 0.36, 1)"
        }
      });
      headerTl.from(".bespoke-eyebrow", {
        opacity: 0,
        y: 12,
        duration: 0.5
      }).from(".bespoke-heading", {
        opacity: 0,
        y: 20,
        duration: 0.7
      }, "-=0.38");
      gsap.from(".bespoke-cell", {
        opacity: 0,
        y: 16,
        duration: 0.6,
        stagger: 0.08,
        ease: "cubic-bezier(0.22, 0.61, 0.36, 1)",
        scrollTrigger: {
          trigger: ".bespoke-grid",
          start: "top 85%"
        }
      });
    });
  }, {
    scope: container
  });
  return <section data-section-id="24617" id="nuestras-especialidades-premium" ref={container} data-nav="light" className="bg-background text-foreground py-28 md:py-36 overflow-hidden">
      <div className="mx-auto max-w-[1360px] px-5 md:px-10">
        <div className="max-w-4xl">
          <div className="bespoke-eyebrow flex items-center gap-3 mb-6">
            <span aria-hidden="true" className="inline-block w-[1.5px] h-3 bg-[var(--rust)]" />
            <span className="font-default text-xs md:text-sm font-semibold uppercase tracking-[0.22em]" style={{
            color: "var(--rust)"
          }}>
              Soluciones Técnicas
            </span>
            <span aria-hidden="true" className="inline-block w-[1.5px] h-3 bg-[var(--rust)]" />
          </div>

          <h2 className="bespoke-heading font-mono uppercase font-bold text-foreground" style={{
          fontSize: "clamp(2.5rem, 5vw, 4.5rem)",
          letterSpacing: "-0.005em",
          lineHeight: 0.96
        }}>
            Nuestros servicios
          </h2>
        </div>

        <div className="bespoke-grid mt-12 md:mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, i) => {
          const IconComponent = service.icon;
          return <div data-index={i} key={service.title} className="bespoke-cell group border border-border bg-card p-8 rounded-2xl flex flex-col justify-between transition-all duration-300 hover:border-[var(--rust)] hover:shadow-md">
                <div>
                  <div className="w-12 h-12 rounded-xl bg-[var(--rust)]/10 text-[var(--rust)] flex items-center justify-center mb-6 group-hover:bg-[var(--rust)] group-hover:text-white transition-colors duration-300">
                    <IconComponent className="w-6 h-6 stroke-[1.75]" />
                  </div>

                  <h3 className="font-mono uppercase font-bold text-[var(--primary)] text-xl md:text-2xl mb-3">
                    {service.title}
                  </h3>

                  <p className="font-default text-muted-foreground text-sm md:text-base leading-relaxed mb-6">
                    {service.description}
                  </p>
                </div>

                <div className="pt-2 mt-auto">
                  <Link to={service.href} className="inline-flex items-center gap-2 font-default text-xs uppercase tracking-[0.1em] font-semibold text-[var(--rust)] hover:text-[var(--rust-ink)] group/link">
                    <span>Ver servicio</span>
                    <ArrowRight className="w-4 h-4 transition-transform duration-200 group-hover/link:translate-x-1" />
                  </Link>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}